import React from "react";

const OPTIONS = [
  { 
    key: "excellent", 
    label: "Excellent", 
    description: "Like new condition",
    color: "from-green-500 to-emerald-500",
    bgColor: "bg-green-50",
    textColor: "text-green-700"
  },
  { 
    key: "very_good", 
    label: "Very Good", 
    description: "Minor wear only",
    color: "from-blue-500 to-cyan-500",
    bgColor: "bg-blue-50",
    textColor: "text-blue-700"
  },
  { 
    key: "good", 
    label: "Good", 
    description: "Normal wear",
    color: "from-yellow-500 to-orange-500",
    bgColor: "bg-yellow-50",
    textColor: "text-yellow-700"
  },
  { 
    key: "fair", 
    label: "Fair", 
    description: "Visible wear",
    color: "from-orange-500 to-red-500",
    bgColor: "bg-orange-50",
    textColor: "text-orange-700"
  }
];

export default function ConditionChecklist({ value = "good", onChange }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {OPTIONS.map((option) => (
          <button
            key={option.key}
            type="button"
            onClick={() => onChange?.(option.key)}
            className={`p-4 rounded-xl border-2 transition-all duration-200 text-left ${
              value === option.key
                ? `bg-gradient-to-r ${option.color} text-white border-transparent shadow-lg transform scale-105`
                : `bg-white ${option.bgColor} ${option.textColor} border-slate-200 hover:border-slate-300 hover:shadow-md`
            }`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-3 h-3 rounded-full ${
                value === option.key ? 'bg-white' : `bg-gradient-to-r ${option.color}`
              }`}></div>
              <div>
                <div className="font-semibold text-sm">{option.label}</div>
                <div className={`text-xs ${
                  value === option.key ? 'text-white/80' : 'text-slate-500'
                }`}>
                  {option.description}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
      
      <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl">
        <div className="flex items-start gap-3">
          <div className="w-5 h-5 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <span className="text-white text-xs">⚠</span>
          </div>
          <div className="text-xs text-amber-800">
            <strong>Safety Note:</strong> For safety-critical items like car seats, include manufacture date and no-crash declaration. 
            Be honest about condition to ensure child safety.
          </div>
        </div>
      </div>
    </div>
  );
}